module.exports = __webpack_public_path__ + "media/images/goods_btn-816c17aeda4be4ea306946bd250bf667.gif";